<panel style="min-width: 400px">
  @if (!pool.id) {
    <h1>{{ 'pool.create-pool' | translate }}</h1>
  }
  @if (pool.id) {
    <h1>{{ 'pool.edit-pool' | translate }}</h1>
  }
  <section>
    <custom-input [label]="'pool.name' | translate"
      [placeholder]="'pool.name-placeholder' | translate"
      [(value)]="pool.name"
    [required]="true"></custom-input>
    <custom-input [label]="'pool.icon' | translate"
      [placeholder]="'pool.icon-placeholder' | translate"
      [(value)]="pool.icon"
    [required]="true"></custom-input>
    <custom-select [label]="'pool.query' | translate"
      [selectList]="queriesList"
      [placeholder]="'pool.query-placeholder' | translate"
      [required]="true"
      (valueChange)="selectQuery($event)"
    [value]="pool.queryId"></custom-select>
    <add-multiple [label]="'pool.teams' | translate"
      [placeholder]="'pool.teams-placeholder' | translate"
      [(selectedItems)]="addedTeams"
      [availableItems]="allTeams"
    [required]="true"></add-multiple>
  </section>
  @if (queryData) {
    <section>
      <query-inputs [name]="selectedQuery?.name ?? ''" [filledQuery]="filledQueryData" [query]="queryData" />
    </section>
  }
  <section>
    <button confirm #saveButton (click)="savePool()" [ignoreValidation]="true">{{ 'general.save' | translate }}</button>
  </section>
</panel>
